import React, { useState } from "react";
import {
  Button,
  Box,
  Typography,
  Divider,
} from "@mui/material";
import EntityForm from "./EntityForm";
import DisplayIcon from "../Icon/DisplayIcon";

const Step2EntityBuilder = ({ entities, setEntities }) => {
  const [showEntityForm, setShowEntityForm] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);

  const addEntity = (entity) => {
    if (editingIndex !== null) {
        const updatedEntities = [...entities];
        updatedEntities[editingIndex] = entity; // Ensure the entire object, including `_id`, is updated
        setEntities(updatedEntities);
    } else {
        setEntities([...entities, entity]);
    }
    setShowEntityForm(false);
    setEditingIndex(null);
};
  const removeEntity = (index) => setEntities(entities.filter((_, i) => i !== index));

  const editEntity = (index) => {
    setEditingIndex(index);
    setShowEntityForm(true);
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Entities
      </Typography>
      <Divider sx={{ mb: 2 }} />
      {entities.length === 0 && (
        <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
          No entities added yet. Click "Add Entity" to create one.
        </Typography>
      )}
        {entities.map((entity, index) => {

        return (
          <Box
            key={index}
            sx={{
              mb: 3,
              border: "1px solid #ccc",
              borderRadius: 2,
              p: 2,
              display: "flex",
              alignItems: "center",
            }}
          >
              <Box sx={{ marginRight: 2, marginTop : 2 }}>
              <DisplayIcon name={entity.icon}></DisplayIcon>
              <Box
                sx={{
                  width: 75,
                  height: 20,
                  backgroundColor: entity.iconColor || "#FFFFFF",
                  border: "1px solid #ccc",
                  borderRadius: 1,
                  mt: 1,
                }}
              />
               
              </Box>
           
            <Box sx={{ flex: 1 }}>
              <Typography variant="subtitle1" fontWeight="bold">
                Name: {entity.name}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Custom Keys: {entity.keys.join(", ")}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Sensors: {entity.sensors.length}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Actions: {entity.actions.length}
              </Typography>
            </Box>
            <Box sx={{ ml: 2, display: "flex", gap: 1 }}>
              <Button variant="outlined" size="small" onClick={() => editEntity(index)}>
                Edit
              </Button>
              <Button
                variant="outlined"
                color="error"
                size="small"
                onClick={() => removeEntity(index)}
              >
                Remove
              </Button>
            </Box>
          </Box>
        );
      })}
      {showEntityForm ? (
        <EntityForm
          onSave={addEntity}
          onCancel={() => {
            setShowEntityForm(false);
            setEditingIndex(null);
          }}
          entity={editingIndex !== null ? entities[editingIndex] : null}
        />
      ) : (
        <Button variant="contained" onClick={() => setShowEntityForm(true)}>
          Add Entity
        </Button>
      )}
    </Box>
  );
};

export default Step2EntityBuilder;
